module.exports = '2.1.5';



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphlib/lib/version.js
// module id = 118
// module chunks = 0